import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBabyFaceGeneratorConfig } from '@/data/landingConfig/landingBabyFaceGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BabyFaceGenerator } from './schemaObject';

interface Props {}
const BabyFaceGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BabyFaceGenerator} />
			<LandingTemplate
				data={landingBabyFaceGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiBabyGenerator()}
			/>
		</>
	);
};

export default BabyFaceGenerator;
